import React from 'react';
import { getCookie, } from 'react-use-cookie';
import { useHistory } from "react-router-dom";
 
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import New_SideBar_2025 from "./New_Sidebar_2025";
import { useCookies } from "react-cookie";
import New_ButtonHilight_2025 from "./New_ButtonHilight_2025";
 
const New_Navigation_2025 = () => {

  const history = useHistory();
  const [cookie, setCookie, removeCookie] = useCookies(['tokenmysych']);
  const [cookie_part, setCookie_part, removeCookie_part] = useCookies(['tokenmysypart']);

  return (
    <div className={"navigation"}>
     
      <div className="test_page">
      <div className="bm-burger-button_label">
        </div>
        <New_SideBar_2025 />
        <New_ButtonHilight_2025 />
      </div>

    </div>


  )
}


export default New_Navigation_2025;